import { Table } from "flowbite-react";
import React, { useState, useEffect, useContext } from "react";
import ReusableDataTable from "../../../hooks/ReusableDataTable";
import { Button, Modal, Label, TextInput, Select } from "flowbite-react";
import { Link, useNavigate } from "react-router-dom";
import { FaCheckCircle, FaRegCheckCircle } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import CompletedCuttingQuantity from "./CompletedCuttingQuantity";
import { AuthContext } from "../../../context/AuthContext";

function Cutting({ orderid, Sub_Order_id }) {
    const navigate = useNavigate();
    const [cuttingData, setCuttingData] = useState([]);
    const [statusModal, setStatusModal] = useState(false);
    const today = new Date().toISOString().split('T')[0];

    const [Input, setInput] = useState({ completedDate: "" });
    const [completeStatusKey, setcompleteStatusKey] = useState(0) //for re render
    const { user } = useContext(AuthContext);

    const role = sessionStorage.getItem('role');

    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {
            // fetchorder();
        }
    }, [user, navigate]);
    // console.log(user)
    const onChangeValue = (e) => {
        setInput({ ...Input, [e.target.name]: e.target.value });
    }

    useEffect(() => {
        fetchCuttingData();
    }, []);

    const fetchCuttingData = async () => {
        try {
            const response = await axios.get(`cutting/cuttings/${orderid}/${Sub_Order_id}`);
            const CuttingData = response.data;
            setCuttingData(CuttingData);
        } catch (error) {
            console.error("Error fetching cutting data:", error);
        }
    };

    const UpdateCompletedstatus = async (inputData) => {
        // console.log(inputData)
        try {
            const res = await axios.post(`cutting/complete_status/${inputData.id}`, {
                completed_date: inputData.completedDate || today,
            });
    
            if (res.data.success === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Cutting Completed ",
                    type: "success",
                    timer: 2000,
                    showConfirmButton: false,
                });
                setcompleteStatusKey((prevKey) => prevKey + 1);
                fetchCuttingData();
            } else {
                Swal.fire({
                    icon: "error",
                    text: "Server Problem. Please Try Again...",
                    type: "error",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }
        } catch (error) {
            console.error("Update error:", error);
        }
    };
    



    const columns = [
        { name: "#", selector: (row) => row.id, sortable: true, width: "60px" },
        { name: "Staff Name", selector: (row) => row.staffname, sortable: true },
        { name: "Cutting No", selector: (row) => row.cuttingno, sortable: true },
        { name: "Layer Length", selector: (row) => row.layerLen, sortable: true },
        { name: "No. of Layers", selector: (row) => row.nooflayer, sortable: true },
        { name: "Marker", selector: (row) => row.sizevariant, sortable: true, width: "150px" },
        { name: "Total Marker", selector: (row) => row.totalvariant, sortable: true },
        ...(role === 'Cutting_Staff' || role === 'super_admin' || role === 'FM'
            ? [{ name: "Status", selector: (row) => row.status, sortable: true }]
            : []),
        
        { name: "Total Piece", selector: (row) => row.totalpiece, sortable: true },
        { name: "Total Fabric", selector: (row) => row.totalfabric, sortable: true },
        
        { name: "Avg CMP per GMT", selector: (row) => row.avgcmp, sortable: true },
        {
            name: "Created at",
            selector: (row) => {
                const date = new Date(row.datetime);
                return [`${date.toLocaleDateString("en-GB")}`, `${date.toLocaleTimeString("en-GB", { hour12: false })}`];
            },
            sortable: true,
            cell: (row) => (
                <div>
                    <div>{new Date(row.datetime).toLocaleDateString("en-GB")}</div>
                    <div>{new Date(row.datetime).toLocaleTimeString("en-GB", { hour12: false })}</div>
                </div>
            )
        },


    ];

    const Data = cuttingData && cuttingData?.cutting_plan?.map((plan, index) => ({
        id: index + 1,
        cuttingno: plan.cuttingNo,
        layerLen: plan.layerLen,
        nooflayer: plan.noLayers,
        sizevariant: plan.formated_size_variant,
        totalvariant: plan.totalvariant,
        totalpiece: plan.totalpiece,
        totalfabric: plan.totalFabric,
        avgcmp: plan.Avgcmp,
        datetime: plan.datatime,
        staffname: plan.staff_name,
        status: (
            <div style={{ display: "flex" }}>
                {plan.work_status === "Completed" ? (
                    <FaCheckCircle
                        className="ml-2 text-green-500 text-2xl"
                    />
                ) : (
                    <FaRegCheckCircle
                        className="ml-2 text-red-500 text-2xl"
                        onClick={() => {
                            const newInput = {
                                completedDate: today,
                                id: plan.cutting_log_Id,
                            };
                            setInput(newInput);
                            setTimeout(() => {
                                UpdateCompletedstatus(newInput);
                            }, 0);
                        }}
                        
                    />
                )}
            </div>
        ),
    })) || [];



    return (
        <>
            {(role === 'Cutting_Staff' || role === 'super_admin' || role === 'FM') &&
                <Button
                    className="bg-icon-color text-sidebar-color drop-shadow-md font-bold"
                    onClick={() => navigate(`/add_cutting/?orderid=${orderid}&sid=${Sub_Order_id}`)}
                >
                    Cutting Details
                </Button>}

            <CompletedCuttingQuantity key={completeStatusKey} orderid={orderid} Sub_Order_id={Sub_Order_id} />

            <div className="overflow-x-auto mt-2">
                <ReusableDataTable columns={columns} data={Data} />
            </div>


            <Modal
                show={statusModal}
                size="md"
                onClose={() => setStatusModal(false)}
                popup
            >
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to complete this cutting?
                        </h3>

                    </div>
                    <div className="space-y-6">

                        <form>
                            <div>
                                <div className="pt-2 text-left mb-2 block">
                                    <Label htmlFor="completed-date" value="Completed Date" />
                                </div>
                                <TextInput
                                    id="completed-date"
                                    name="completedDate"
                                    type="date"
                                    required
                                    autoComplete="off"
                                    value={today} // set default value
                                    min={today}   // disable past dates
                                    max={today}   // disable future dates
                                    onChange={onChangeValue}
                                />

                            </div>

                            <div className="pt-3 w-full flex justify-center">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit" onClick={UpdateCompletedstatus}>
                                    Submit
                                </Button>
                                <Button className="ml-2" color="gray" onClick={() => setStatusModal(false)}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Cutting;
